import Vue from 'vue'
import Router from 'vue-router'
import Parents from '@/components/Parents'
import CreateRegistration from '@/components/CreateRegistration'
import VDateRange from 'vuetify-daterange-picker';
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css';

Vue.use(Router)
Vue.use(VDateRange)

export default new Router({
  routes: [{
      path: '',
      redirect: '/parents'
    },
    {
      path: '/parents',
      name: 'Parents',
      component: Parents,
      children: [{
          path: '',
          redirect: 'create-registration'
        },
        {
          path: 'create-registration',
          component: CreateRegistration
        }
      ]
    }
  ]
})
